// import React, { useEffect, useState } from 'react';

// function App() {
//   const [status, setStatus] = useState<string>('Loading…');

//   useEffect(() => {
//     fetch('/api/health')
//       .then((res) => res.json())
//       .then((data) => setStatus(data.status))
//       .catch(() => setStatus('Error'));
//   }, []);

//   return (
//     <div style={{ padding: 24 }}>
//       <h1>API Status: {status}</h1>
//     </div>
//   );
// }

// export default App;

// frontend/src/App.tsx
// Yfirlit læknis er landing page hér
// import React from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import DoctorDashboard from './pages/DoctorDashboard';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* ...other routes... */}
//         <Route path="/doctor" element={<DoctorDashboard />} />
//         <Route path="*" element={<Navigate to="/doctor" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DoctorDashboard from './pages/DoctorDashboard';
import DoctorLandingPage from './pages/DoctorLandingPage';
import PatientNotFound from './pages/PatientNotFound';
import DoctorChangesPage from './pages/DoctorChangesPage';
import PharmacistLandingPage from './pages/PharmacistLandingPage';
import StartSubscriptionPage from './pages/StartSubscriptionPage';
import PharmacistPatient from './pages/PharmacistPatient';
import DoctorChangeDetailPage from './pages/DoctorChangeDetailPage';
import PharmacistFinishedChangesPage from './pages/PharmacistFinishedChangesPage';
import PharmacistFinishedChangeDetailPage from './pages/PharmacistFinishedChangeDetailPage';
import HomePage from './pages/HomePage';
import Forbidden from './pages/Forbidden';
import ProtectedRoute from './auth/ProtectedRoute';
import RoleRoute from './auth/RoleRoute';
import AccessDenied from './pages/AccessDenied';
import LogoutPage from './pages/LogoutPage';
import { useBootstrapSession } from './auth/useBootstrapSession';
import { useSessionContext } from './session/SessionContext';

function App() {
  const bootstrap = useBootstrapSession();
  const { setContext } = useSessionContext();

  // When bootstrap becomes ready, store context globally
  React.useEffect(() => {
    if (bootstrap.status === 'ready') {
      setContext(bootstrap.context);
    }
  }, [bootstrap, setContext]);

  // Allow public routes to render even when not authenticated
  // (login, forbidden, access-denied)
  // For everything else, wait for bootstrap once authenticated.

  if (bootstrap.status === 'loading') {
    return <div style={{ padding: 24 }}>Setting up your session…</div>;
  }

  if (bootstrap.status === 'error') {
    return (
      <div style={{ padding: 24 }}>
        <h2>Session setup failed</h2>
        <pre style={{ whiteSpace: 'pre-wrap' }}>{bootstrap.message}</pre>
      </div>
    );
  }

  if (bootstrap.status === 'needsSelection') {
    return (
      <div style={{ padding: 24 }}>
        <h2>Select your context</h2>
        <pre style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(bootstrap.options, null, 2)}</pre>
        {/* next step: build selection UI and call /api/session/select-context */}
      </div>
    );
  }

  // bootstrap.status is "idle" (not logged in) or "ready"
  return (
    <Routes>
      {/* Landing page is now LoginPage */}
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forbidden" element={<Forbidden />} />
      <Route path="/access-denied" element={<AccessDenied />} />

      <Route
        path="/notfound"
        element={
          <ProtectedRoute>
            <PatientNotFound />
          </ProtectedRoute>
        }
      />

      {/* After login, routes like /doctor go to the dashboard */}
      {/* This page redirects to /doctor or /pharmacist based on role */}
      <Route
        path="/"
        element={
          <RoleRoute allowedRoles={['DOCTOR', 'PHARMACIST_LSH', 'PHARMACIST']}>
            <HomePage />
          </RoleRoute>
        }
      />

      <Route
        path="/doctor-landing"
        element={
          <RoleRoute allowedRoles={['DOCTOR', 'PHARMACIST_LSH']}>
            <DoctorLandingPage />
          </RoleRoute>
        }
      />

      <Route
        path="/doctor"
        element={
          <RoleRoute allowedRoles={['DOCTOR', 'PHARMACIST_LSH']}>
            <DoctorLandingPage />
          </RoleRoute>
        }
      />

      <Route
        path="/doctor/patient/:patientId"
        element={
          <RoleRoute allowedRoles={['DOCTOR', 'PHARMACIST_LSH']}>
            <DoctorDashboard />
          </RoleRoute>
        }
      />

      <Route
        path="/doctor/patient/new"
        element={
          <RoleRoute allowedRoles={['DOCTOR', 'PHARMACIST_LSH']}>
            <DoctorDashboard />
          </RoleRoute>
        }
      />

      <Route
        path="/doctor/changes"
        element={
          <RoleRoute allowedRoles={['DOCTOR', 'PHARMACIST_LSH']}>
            <DoctorChangesPage />
          </RoleRoute>
        }
      />

      <Route
        path="/doctor/changes/:workOrderId"
        element={
          <RoleRoute allowedRoles={['DOCTOR', 'PHARMACIST_LSH']}>
            <DoctorChangeDetailPage />
          </RoleRoute>
        }
      />

      <Route
        path="/pharmacist"
        element={
          <RoleRoute allowedRoles={['PHARMACIST']}>
            <PharmacistLandingPage />
          </RoleRoute>
        }
      />

      <Route
        path="/pharmacist/work-order/:workOrderId"
        element={
          <RoleRoute allowedRoles={['PHARMACIST']}>
            <PharmacistPatient />
          </RoleRoute>
        }
      />

      <Route
        path="/doctor/start-subscription"
        element={
          <RoleRoute allowedRoles={['DOCTOR', 'PHARMACIST_LSH']}>
            <StartSubscriptionPage />
          </RoleRoute>
        }
      />

      {/* <Route
        path="/pharmacist/search"
        element={
          <RoleRoute allowedRoles={['PHARMACIST']}>
            <PharmacistSearchPage />
          </RoleRoute>
        }
      /> */}

      {/* <Route
        path="/pharmacist/patient"
        element={
          <RoleRoute allowedRoles={['PHARMACIST']}>
            <PharmacistPatient />
          </RoleRoute>
        }
      /> */}

      <Route
        path="/pharmacist/finished"
        element={
          <RoleRoute allowedRoles={['PHARMACIST']}>
            <PharmacistFinishedChangesPage />
          </RoleRoute>
        }
      />

      <Route
        path="/pharmacist/finished/:workOrderId"
        element={
          <RoleRoute allowedRoles={['PHARMACIST']}>
            <PharmacistFinishedChangeDetailPage />
          </RoleRoute>
        }
      />

      {/* Test for auth0 login/logout */}
      <Route
        path="/logout"
        element={
          <RoleRoute allowedRoles={['PHARMACIST', 'DOCTOR', 'PHARMACIST_LSH']}>
            <LogoutPage />
          </RoleRoute>
        }
      />

      {/* Catch-all redirects to the login page */}
      {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
